
class Comprobante {
    fh_cobro = null;
    importe = null;
    num_com = null;
    per_has = null;
    pre_com = null;
    tpo_com = null;

    tipo_full = null;
    tipos = {
        "NC": "Nota de Credito",
        "FC": "Facturas",
        "FCPF": "Facturas Plan de Financiación",
        "PCR": "Pago Duplicado",
        "PCRM": "Plata a Cuenta"
    };

    comprobante = null;

    seleccionable = null;

    constructor(obj) {
        // IF AN OBJECT WAS PASSED THEN INITIALISE PROPERTIES FROM THAT OBJECT
        for (var prop in obj) this[prop] = obj[prop];

        this.fh_cobro = this.fh_cobro.replaceAll(' 12:00:00 a. m.', '');
        var dateParts = this.fh_cobro.split("/");
        var date = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]); 
        this.fh_cobro = this.formatDateComprobante(date);

        this.per_has = this.per_has.replaceAll(' 12:00:00 a. m.', '');
        dateParts = this.per_has.split("/");
        date = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        this.per_has = this.periodoComprobante(date);

        this.comprobante = this.tpo_com+'-'+this.pre_com+'-'+this.num_com;
        this.tipo_full = this.tipos[this.tpo_com.trim()];
    }

    formatDateComprobante(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [day, month, year].join('/');
    }

    periodoComprobante(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [month, year].join('-');
    }
}

export default Comprobante